import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setIsOpen(false);
    };
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const deepBlue = '#0A2F44';
  const silver = '#F0F4F8';
  const brightSilver = '#FFFFFF';
  const activeGlow = '#FFD966';

  const navContainerStyle = {
    background: deepBlue,
    padding: '0.5rem 1rem',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    transition: 'box-shadow 0.3s',
    boxShadow: scrolled ? '0 4px 20px rgba(0,0,0,0.2)' : 'none',
  };

  const navContentStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
  };

  const logoStyle = {
    color: silver,
    fontSize: '1.5rem',
    fontWeight: 'bold',
    textDecoration: 'none',
  };

  const hamburgerStyle = {
    display: isMobile ? 'block' : 'none',
    background: 'none',
    border: 'none',
    color: silver,
    fontSize: '1.8rem',
    cursor: 'pointer',
  };

  const menuStyle = {
    display: isMobile ? (isOpen ? 'flex' : 'none') : 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    position: isMobile ? 'absolute' : 'static',
    top: isMobile ? '100%' : 'auto',
    left: 0,
    right: 0,
    backgroundColor: isMobile ? deepBlue : 'transparent',
    padding: isMobile ? '1rem' : '0',
    gap: isMobile ? '1rem' : '1.8rem',
    zIndex: 999,
    animation: isMobile && isOpen ? 'slideDown 0.3s ease' : 'none',
  };

  const linkBaseStyle = {
    color: silver,
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '1rem',
    padding: isMobile ? '0.75rem 0' : '0.5rem 0',
    display: 'inline-block',
    transition: 'color 0.2s, text-shadow 0.2s, transform 0.2s',
    textShadow: '0 0 3px rgba(240,244,248,0.3)',
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 998,
    display: isMobile && isOpen ? 'block' : 'none',
    animation: 'fadeIn 0.2s ease',
  };

  const animationStyles = `
    @keyframes slideDown {
      from { opacity: 0; transform: translateY(-10px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    .nav-link, .dropdown-link {
      transition: all 0.2s ease;
    }
    .nav-link:hover, .dropdown-link:hover {
      color: ${brightSilver};
      text-shadow: 0 0 12px rgba(240,244,248,0.9);
      transform: translateY(-2px) scale(1.02);
    }

    .active-link {
      color: ${brightSilver};
      text-shadow: 0 0 12px ${activeGlow};
    }
  `;

  const getActiveClassName = ({ isActive }) =>
    isActive ? 'active-link nav-link' : 'nav-link';

  return (
    <>
      <style>{animationStyles}</style>

      <nav style={navContainerStyle}>
        <div style={navContentStyle}>
          <NavLink
            to="/"
            style={{
              ...logoStyle,
              display: 'flex',
              alignItems: 'center',
            }}
            onClick={closeMenu}
          >
            <img
              src="/septic.png"
              alt="logo"
              style={{
                height: '70px',
                width: '70px',
                objectFit: 'contain',
              }}
            />
          </NavLink>

          <button onClick={toggleMenu} style={hamburgerStyle}>
            ☰
          </button>

          <div style={menuStyle}>
            <NavLink to="/" style={linkBaseStyle} className={getActiveClassName} onClick={closeMenu} end>
              Home
            </NavLink>

            <NavLink to="/about" style={linkBaseStyle} className={getActiveClassName} onClick={closeMenu}>
              About
            </NavLink>

            <NavLink to="/services" style={linkBaseStyle} className={getActiveClassName} onClick={closeMenu}>
              Services
            </NavLink>

            <NavLink to="/contact" style={linkBaseStyle} className={getActiveClassName} onClick={closeMenu}>
              Contact
            </NavLink>
          </div>
        </div>
      </nav>

      <div style={overlayStyle} onClick={closeMenu} />
    </>
  );
};

export default Navbar;